import { useState } from 'react';
import { HighlightedCode } from '../HighlightedCode';
import { Button } from '../Button';
import { CopyButton } from '../CopyButton';
import { DownloadIcon, WrapIcon } from '../icons';
import { downloadBlob } from './download';

// Extension du fichier téléchargé selon le langage du bloc
const EXTENSIONS = {
  sql: 'sql', js: 'js', javascript: 'js', jsx: 'jsx', ts: 'ts', typescript: 'ts', tsx: 'tsx',
  json: 'json', py: 'py', python: 'py', bash: 'sh', sh: 'sh', shell: 'sh', zsh: 'sh',
  yaml: 'yaml', yml: 'yaml', css: 'css', html: 'html', xml: 'xml', csv: 'csv', md: 'md', markdown: 'md',
};

/** Visionneuse « Code » : coloration, numéros de ligne, retour à la ligne, copie, téléchargement. */
export function CodeArtifact({ artifact }) {
  const { code = '', language = '' } = artifact.payload ?? {};
  const [wrap, setWrap] = useState(false);
  const lines = code.split('\n').length;
  const ext = EXTENSIONS[String(language).toLowerCase()] ?? 'txt';

  return (
    <div className="artifact-view artifact-code">
      <div className="artifact-toolbar" role="toolbar" aria-label="Actions sur le code">
        <span className="artifact-toolbar__meta ds-num">
          {language || 'texte'} · {lines} ligne{lines > 1 ? 's' : ''}
        </span>
        <div className="artifact-toolbar__actions">
          <Button variant="ghost" size="sm" icon={WrapIcon} aria-pressed={wrap} onClick={() => setWrap((v) => !v)}>
            <span>Retour à la ligne</span>
          </Button>
          <CopyButton getText={() => code} label="Copier le code" showLabel size={14} />
          <Button variant="ghost" size="sm" icon={DownloadIcon} onClick={() => downloadBlob(code, `code.${ext}`)}>
            <span>Télécharger</span>
          </Button>
        </div>
      </div>

      <div className={`md artifact-code__body ${wrap ? 'is-wrapped' : ''}`}>
        {!wrap && (
          <div className="artifact-code__gutter ds-num" aria-hidden="true">
            {Array.from({ length: lines }, (_, i) => <span key={i}>{i + 1}</span>)}
          </div>
        )}
        <pre tabIndex={0} aria-label={`Code ${language || ''}, ${lines} lignes`.trim()}>
          <HighlightedCode code={code} language={language} />
        </pre>
      </div>
    </div>
  );
}
